var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spinner spinner--socker", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _vm._m(0)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cube panelLoad" }, [
      _c("div", { staticClass: "cube-face cube-face-front" }, [_vm._v("L")]),
      _vm._v(" "),
      _c("div", { staticClass: "cube-face cube-face-back" }, [_vm._v("O")]),
      _vm._v(" "),
      _c("div", { staticClass: "cube-face cube-face-left" }, [_vm._v("A")]),
      _vm._v(" "),
      _c("div", { staticClass: "cube-face cube-face-right" }, [_vm._v("D")]),
      _vm._v(" "),
      _c("div", { staticClass: "cube-face cube-face-bottom" }, [_vm._v("I")]),
      _vm._v(" "),
      _c("div", { staticClass: "cube-face cube-face-top" }, [_vm._v("N'")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21515d1f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21515d1f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-loading-spinner/src/components/LetterCube.vue
// module id = 363
// module chunks = 2